export const languageTypes = {
  ENGLISH: 'US',
  NEPALI: 'NP',
};
